import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { C_Button } from "../../Common/CommonButton";
import { C_Select } from "../../../CustomValidateForm";
import { GET_COMPANY_FROM_URL, isAdminDivisionRole, loginCompanyID, loginEmployeeID, loginUserAdminRole, loginUserDetails, loginUserIsCBMAttribRole } from "../../Common/CommonFunction";
import { commonPartyDropSelectAction } from "../../../store/Utilites/PartyDrodown/action";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import './changeParty.scss'; // Add your styles here
import { useRef } from "react";
import { showToastAlert } from "../../../helpers/axios_Config";
import { alertMessages } from "../../Common/CommonErrorMsg/alertMsg";
import { canSwitchUserAccess, hideBtnCss } from "../../Common/ListActionsButtons";
import { Col, Spinner } from "reactstrap";
import { url } from "../../../routes";
import { useHistory } from 'react-router-dom';
import { getPartyEmployeeDetails } from "../../../store/Administrator/PartyEmployeeDetailsRedux/action";
import { getpartysetting_API, getpartysetting_API_Success } from "../../../store/Administrator/PartySetting/action";
import { getUserList } from "../../../store/Administrator/UserRegistrationRedux/actions";
import { divisionDropdown_Forlogin_ChangeDivisionPage_ApiCall } from "../../../helpers/backend_helper";
import { impersonationSetState } from "../../../store/Utilites/Impersonation/action";
import {
    clearRoleAccessForUserSwitch,
    getUserDisplayNameForImpersonation,
    impersonationStorageKeys,
    makeSessionSnapshot,
    normalizeSwitchUserRecord,
    runLoginUserBootstrap,
} from "../../Common/ImpersonationFunc";

const ChangeCommonParty = (props) => {

    const dispatch = useDispatch();
    const componentRef = useRef(null);
    const history = useHistory()

    // Local state
    const [selectedParty, setSelectedParty] = useState({ value: 0, label: "select party...", SAPPartyCode: "" });
    const [selectedUser, setSelectedUser] = useState({ value: 0, label: "select user..." });
    const [selectedPartyRole, setSelectedPartyRole] = useState(null);
    const [targetPartyRoles, setTargetPartyRoles] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUserSwitchLoading, setIsUserSwitchLoading] = useState(false);

    // Selectors from Redux store
    const {
        commonPartyDropdownOption,
        partyDropdownLoading,
        commonPartyDropSelect,
        forceDisable,
        isShow,
        isShowOnlySAPParty
    } = useSelector((state) => state.CommonPartyDropdownReducer);


    const { loading } = useSelector((state) => ({
        loading: state.PartyEmployeeDetailsReducer.loading,
    }));

    const {
        isImpersonating,
        userList,
        userListLoading,
        RoleAccessUpdateData
    } = useSelector((state) => ({
        isImpersonating: state.ImpersonationReducer.isImpersonating,
        userList: state.User_Registration_Reducer.pages,
        userListLoading: state.User_Registration_Reducer.loading,
        RoleAccessUpdateData: state.Login.RoleAccessUpdateData,
    }));

    // useEffect to update selected party when commonPartyDropSelect changes
    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {

            setSelectedParty(commonPartyDropSelect);
        }
    }, [commonPartyDropSelect]);


    useEffect(() => {
        const closeDrawerOnOutsideClick = (event) => {
            // Check if the click is outside the component and if the drawer is open
            if (componentRef.current && isDrawerOpen && !componentRef.current.contains(event.target)) {
                setIsDrawerOpen(false);
            }
        };

        // Add event listener to the document for outside clicks
        document.addEventListener("mousedown", closeDrawerOnOutsideClick);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener("mousedown", closeDrawerOnOutsideClick);
        };
    }, [isDrawerOpen]);

    // Function to handle party dropdown selection — fires getUserList
    // immediately with the SELECTED party's id, so the Switch User
    // dropdown is scoped to that party right away (not the logged-in
    // user's own party, and not waiting for the Select button click).
    const handlePartyChange = (party) => {
        setSelectedParty(party);
        setSelectedUser({ value: 0, label: "select user..." });
        setSelectedPartyRole(null);
        setTargetPartyRoles([]);

        if (party?.value > 0 && canSwitchUser) {
            dispatch(getUserList(party.value));
        }
    };

    // Select button: unchanged, it already loads the selected party's settings
    const updateSelectedParty = () => {
        if (selectedParty.value === 0) {
            customAlert({ Type: 3, Message: alertMessages.selectPartyName });
            return;
        }
        setIsDrawerOpen(false);
        dispatch(commonPartyDropSelectAction(selectedParty));
        dispatch(getpartysetting_API(selectedParty.value, loginCompanyID()));
        localStorage.setItem(`${GET_COMPANY_FROM_URL()}_selectedParty`, JSON.stringify(selectedParty));
    };

    // Change / unselect: now also calls the party-wise setting API
    const handleClearBtn = () => {
        const emptyParty = { value: 0, label: "select party...", SAPPartyCode: "" };

        setSelectedParty(emptyParty);
        setSelectedUser({ value: 0, label: "select user..." });
        setSelectedPartyRole(null);
        setTargetPartyRoles([]);

        dispatch(commonPartyDropSelectAction(emptyParty));

        // clear the old party's settings, then call the setting API for "no party"
        dispatch(getpartysetting_API_Success([]));
        dispatch(getpartysetting_API(0, loginCompanyID()));

        localStorage.setItem(`${GET_COMPANY_FROM_URL()}_selectedParty`, JSON.stringify({ value: 0, label: "select...", SAPPartyCode: "" }));
    };

    const PartyDropdownOptions = commonPartyDropdownOption.map(data => ({
        value: data.id,
        label: data.Name,
        SAPPartyCode: data.SAPPartyCode,
        Latitude: data.Latitude,
        Longitude: data.Longitude,
        MobileNo: data.MobileNo,
        Address: data.Address,
        PartyType: data.PartyType,
        PartyTypeID: data.PartyTypeID,
        IsFranchise: data.IsFranchise

    })).filter(index => !isShowOnlySAPParty || index.SAPPartyCode !== null);

    const userOptions = (userList || [])
        .map(normalizeSwitchUserRecord)
        .filter((item) => item.Employee_id)
        .filter((item, index, self) => self.findIndex((row) => row.Employee_id === item.Employee_id) === index);

    const partyRoleOptions = targetPartyRoles.map((item, index) => ({
        value: index,
        label: `${item.PartyName || "No party"} - ${item.RoleName || item.PartyType || "Role"}`,
        roleDetails: item,
    }));

    // Function to toggle drawer
    const handleLabelClick = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };



    // Function to check is party wise page and has show true
    function funcSelectedPartylabel() {
        if (!props.isPartyWisePage || !isShow) {
            return "Party not required."
        }
        //to capitalize the first letter and convert the rest to lowercase
        const partylable = commonPartyDropSelect?.label || ''
        return partylable.charAt(0).toUpperCase() + partylable.slice(1).toLowerCase();
    }

    const handleClick = () => {
        setIsLoading(true);
        dispatch(getPartyEmployeeDetails({ EmployeeId: loginEmployeeID() }))




        setTimeout(() => {
            history.push(url.PARTY_EMPLOYEE_DETAILS);
            setIsLoading(false);
        }, 1000);
    };

    const fetchTargetPartyRoles = async (user) => {
        setSelectedUser(user);
        setSelectedPartyRole(null);
        setTargetPartyRoles([]);

        if (!user?.Employee_id) {
            return;
        }

        if (Number(user.Employee_id) === Number(loginEmployeeID())) {
            customAlert({ Type: 3, Message: "You are already viewing as this user." });
            setSelectedUser({ value: 0, label: "select user..." });
            return;
        }

        setIsUserSwitchLoading(true);
        try {
            const response = await divisionDropdown_Forlogin_ChangeDivisionPage_ApiCall(user.Employee_id);
            const roleRows = (response.Data || []).map((roleRow) => ({
                ...roleRow,
                Party_id: roleRow.Party_id === null ? 0 : roleRow.Party_id,
                SwitchUserID: user.UserID,
                SwitchUserName: user.UserName,
                SwitchEmployeeName: user.EmployeeName,
            }));

            if (roleRows.length === 0) {
                customAlert({ Type: 4, Message: "No role/party access found for this user." });
                return;
            }

            setTargetPartyRoles(roleRows);
            setSelectedPartyRole({
                value: 0,
                label: `${roleRows[0].PartyName || "No party"} - ${roleRows[0].RoleName || roleRows[0].PartyType || "Role"}`,
                roleDetails: roleRows[0],
            });
        } catch (error) {
            customAlert({ Type: 4, Message: "Unable to load this user's role details." });
        } finally {
            setIsUserSwitchLoading(false);
        }
    };

    const updateTargetUserStorage = (targetUser, targetRole) => {
        const company = GET_COMPANY_FROM_URL();

        if (targetUser.UserID !== undefined && targetUser.UserID !== null) {
            localStorage.setItem(`${company}_userId`, targetUser.UserID);
        }

        if (targetUser.UserName) {
            localStorage.setItem(`${company}_UserName`, targetUser.UserName);
        }

        if (targetRole.Employee_id !== undefined && targetRole.Employee_id !== null) {
            localStorage.setItem(`${company}_EmployeeID`, targetRole.Employee_id);
        }

        localStorage.setItem(`${company}_EmployeeName`, getUserDisplayNameForImpersonation(targetUser));
    };

    const switchUserHandler = async () => {
        if (isImpersonating) {
            showToastAlert("Switch back before switching to another user.", "warning");
            return;
        }

        const targetRole = selectedPartyRole?.roleDetails;

        if (!selectedUser?.Employee_id || !targetRole) {
            customAlert({ Type: 3, Message: "Please select user." });
            return;
        }

        const switchConfirm = await customAlert({
            Type: 7,
            Message: `Switch to ${getUserDisplayNameForImpersonation(selectedUser)}?`,
        });

        if (!switchConfirm) {
            return;
        }

        const { originalUserSession, isImpersonating: isImpersonatingKey } = impersonationStorageKeys();
        const snapshot = makeSessionSnapshot();

        localStorage.setItem(originalUserSession, JSON.stringify(snapshot));
        localStorage.setItem(isImpersonatingKey, "true");

        updateTargetUserStorage(selectedUser, targetRole);
        clearRoleAccessForUserSwitch(dispatch);
        runLoginUserBootstrap(targetRole, dispatch, { preserveSelectedParty: false });

        dispatch(impersonationSetState({
            isImpersonating: true,
            originalUser: snapshot.roleId,
            activeUser: targetRole,
        }));

        setIsDrawerOpen(false);
        showToastAlert(`Viewing as ${getUserDisplayNameForImpersonation(selectedUser)}`, "success");
    };

    if (!isAdminDivisionRole()) {
        return null;
    };

    const canSwitchUser = canSwitchUserAccess(RoleAccessUpdateData) && (loginUserDetails().id === 4744) // for now this CBMAttrib role added for testing purpose so it wont affect on anything

    const partyControlsDisabled = !props.isPartyWisePage || !isShow || forceDisable;
    const partylabelStyle = partyControlsDisabled ? { color: "gray" } : {};

    return (
        <div className="change-party-contener" ref={componentRef}>
            <div className="party-label-wapper" onClick={handleLabelClick}>
                <div className="party-label" style={partylabelStyle}  >
                    <i className="fas fa-user pr-1" style={{ paddingTop: "7px", fontSize: "small" }}></i>
                    <span className="party-label-name">{funcSelectedPartylabel()}</span>
                </div>
                <div style={{ alignSelf: "center", ...partylabelStyle }}>
                    {isDrawerOpen ? <i className="fas fa-times"></i> : <i className="fas fa-angle-right"></i>}
                </div>
            </div>

            {isDrawerOpen && (
                <div className="mini-drawer">
                    <div className="c_modal-content">
                        <div style={{ boxShadow: "none" }} className="modal-header c_card_filter text-black"                                >
                            <strong> Party selection </strong>

                            <button
                                type="button"
                                onClick={() => setIsDrawerOpen(false)}
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                style={{ color: "black", fontWeight: "bold" }}
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="switch-panel-section">
                                <div className="switch-panel-label">Party</div>
                            </div>
                            <C_Select
                                value={selectedParty}
                                styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                isSearchable={true}
                                isLoading={partyDropdownLoading}
                                className="react-dropdown"
                                classNamePrefix="dropdown"

                                options={PartyDropdownOptions}
                                isDisabled={partyControlsDisabled || (commonPartyDropSelect.value > 0)}
                                onChange={handlePartyChange}
                            />
                            {selectedParty.value > 0 && <div className="mt-2">
                                <span className="mb-1" style={{ display: 'block' }}> <strong>Party Type: </strong> {selectedParty.PartyType}</span>

                                <span className="mb-1" style={{ display: 'block' }}><strong>Address: </strong>{selectedParty.Address}</span>

                                <span style={{ display: 'block' }}> <strong>Contact: </strong> <a href={"tel:" + selectedParty.MobileNo}>{selectedParty.MobileNo}</a></span>

                            </div>}
                            {canSwitchUser && (<>
                                <div className="switch-panel-divider"></div>
                                <div className="switch-panel-section">
                                    <div className="switch-panel-label">Switch User</div>
                                    {isImpersonating && (
                                        <div className="switch-panel-note">Switch back before selecting another user.</div>
                                    )}
                                </div>
                                <C_Select
                                    value={selectedUser}
                                    styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                    isSearchable={true}
                                    isLoading={userListLoading}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={userOptions}
                                    isDisabled={isImpersonating}
                                    onChange={fetchTargetPartyRoles}
                                />
                                {isUserSwitchLoading && (
                                    <div className="mt-2 text-center">
                                        <Spinner style={{ width: "15px", height: "15px" }} />
                                    </div>
                                )}
                                {partyRoleOptions.length > 1 && (
                                    <div className="mt-2">
                                        <C_Select
                                            value={selectedPartyRole}
                                            styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                            isSearchable={true}
                                            className="react-dropdown"
                                            classNamePrefix="dropdown"
                                            options={partyRoleOptions}
                                            isDisabled={isImpersonating}
                                            onChange={setSelectedPartyRole}
                                        />
                                    </div>
                                )}
                                {selectedPartyRole?.roleDetails && (
                                    <div className="mt-2">
                                        <span className="mb-1" style={{ display: 'block' }}><strong>Party: </strong>{selectedPartyRole.roleDetails.PartyName}</span>
                                        <span className="mb-1" style={{ display: 'block' }}><strong>Party Type: </strong>{selectedPartyRole.roleDetails.PartyType}</span>
                                    </div>
                                )}
                            </>)}
                        </div>
                        <div className="modal-footer d-flex align-items-center justify-content-center flex-wrap" style={{ gap: "8px" }}>
                            {selectedParty.value > 0 && (
                                <C_Button
                                    type="button"
                                    className={`${hideBtnCss} px-2`}
                                    title={"Party Location"}
                                    forceDisabled={partyControlsDisabled}
                                    onClick={() => {
                                        if (
                                            selectedParty &&
                                            selectedParty.Latitude !== undefined &&
                                            selectedParty.Longitude !== undefined &&
                                            selectedParty.Latitude !== null &&
                                            selectedParty.Longitude !== null
                                        ) {
                                            window.open(`https://maps.google.com/?q=${selectedParty.Latitude},${selectedParty.Longitude}`, "_blank");
                                        }
                                    }}
                                >
                                    <i className="bx bx-map-pin"></i>
                                </C_Button>
                            )}

                            <C_Button
                                type="button"
                                className={`${"badge badge-soft-info font-size-12 btn btn-info waves-effect waves-light w-xxs border border-light"} px-2`}
                                title={"Party Employee Details"}
                                forceDisabled={partyControlsDisabled}
                                onClick={handleClick}
                            >
                                {isLoading || loading ? <Spinner style={{ width: "15px", height: "15px" }} /> : <i className="fas fa-users"></i>}
                            </C_Button>

                            {canSwitchUser && (
                                <C_Button
                                    type="button"
                                    loading={isUserSwitchLoading}
                                    spinnerColor="white"
                                    forceDisabled={isImpersonating}
                                    className="btn btn-outline-primary border-1 font-size-12 text-center"
                                    onClick={switchUserHandler}
                                >
                                    Switch
                                </C_Button>
                            )}

                            {!(commonPartyDropSelect.value > 0) ? (
                                <C_Button
                                    type="button"
                                    className="btn btn-primary border-1 font-size-12 text-center"
                                    forceDisabled={partyControlsDisabled}
                                    onClick={updateSelectedParty}
                                >
                                    Select
                                </C_Button>
                            ) : (
                                <C_Button
                                    type="button"
                                    className="btn btn-success border-1 font-size-12 text-center"
                                    forceDisabled={partyControlsDisabled}
                                    onClick={handleClearBtn}
                                >
                                    Change
                                </C_Button>
                            )}
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default ChangeCommonParty;